// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xU7h","footer":"styles_footer__aOEcs","passCodeTooltip":"styles_passCodeTooltip__18Tjr"};